import React, { createContext, useState } from "react";

const ImageUploaderContext = createContext();

export const ImageUploaderProvider = ({ children }) => {
  const [uploader, setUploader] = useState({
    modalCloseTimer: 2000,
    error: null,
    fetchedFilesTotal: 0,
    isDisabled: false,
    refresh: false,
    openModal: false,
  });

  return (
    <ImageUploaderContext.Provider value={{ uploader, setUploader }}>
      {children}
    </ImageUploaderContext.Provider>
  );
};

export default ImageUploaderContext;
